import { CharacterInitializer } from "../../../../../entities/characters/Character";
import { PerkInitializer } from "../../../../../entities/library/perks/Perk";
import { OwnedReference } from "../../../../../entities/Ownership";
import { ErrorToast, InfoToast } from "../../../../../entities/toasts/Toasts";
import { getUniqueIdentifier } from "../../../../../utils/GUID";
import { ApiDefaultState } from "../../../api/ApiStore.State";
import { AppThunkAction } from "../../../ApplicationState";
import { ToastAction, ToastDispatchables } from "../../../toasts/Toasts.Actions";

export type CharacterSavePerk = { type: 'CHARACTER_SAVE_PERK', characterId: string, reference: OwnedReference };
export type CharacterAddPerk = { type: 'CHARACTER_ADD_PERK', characterId: string, reference: OwnedReference };
export type CharacterRemovePerk = { type: 'CHARACTER_REMOVE_PERK', characterId: string, perkInstanceId: string };

export type CharacterPerkAction = CharacterSavePerk | CharacterAddPerk | CharacterRemovePerk;

export const CharacterPerkActions = {
    addPerk: (character: CharacterInitializer, perk: PerkInitializer): AppThunkAction<CharacterPerkAction | ToastAction> =>
        async (dispatch, getState) => {
            const instanceId = getUniqueIdentifier();
            const placeholder = { ...perk, instanceId };

            const undo = () => {
                dispatch({ type: 'CHARACTER_REMOVE_PERK', characterId: character.id, perkInstanceId: instanceId });
                ToastDispatchables.toastLegacy(new ErrorToast(`Error adding ${perk.name}.`), dispatch);
            }
            dispatch({ type: 'CHARACTER_ADD_PERK', characterId: character.id, reference: placeholder });

            try {
                const response = await ApiDefaultState.characters.addPerk(character.id, perk.id);
                if (response.status == 'Success') {
                    dispatch({ type: 'CHARACTER_SAVE_PERK', characterId: character.id, reference: { ...perk, instanceId: response.payload } });
                    ToastDispatchables.toastLegacy(new InfoToast(`${perk.name} added.`), dispatch);
                }
                else {
                    undo();
                    ToastDispatchables.toastValidationResults(response.validationResults, dispatch);
                }
            }
            catch (e) {
                undo();
                console.error(e);
            }
        },

    removePerk: (character: CharacterInitializer, reference: OwnedReference): AppThunkAction<CharacterPerkAction | ToastAction> =>
        async (dispatch, getState) => {
            const perk = getState().library.perks.find(p => p.id == reference.id);
            if (perk == null) {
                ToastDispatchables.toastLegacy(new ErrorToast("Backing perk not found."), dispatch);
                return;
            }

            const undo = () => {
                dispatch({ type: 'CHARACTER_ADD_PERK', characterId: character.id, reference });
                ToastDispatchables.toastLegacy(new ErrorToast(`Error removing ${perk.name}.`), dispatch);
            }
            dispatch({ type: 'CHARACTER_REMOVE_PERK', characterId: character.id, perkInstanceId: reference.instanceId });

            try {
                const response = await ApiDefaultState.characters.removePerk(character.id, reference.id);
                if (response.status == 'Success') {
                    ToastDispatchables.toastLegacy(new InfoToast(`${perk.name} removed.`), dispatch);
                }
                else {
                    undo();
                }
            }
            catch (e) {
                undo();
                console.error(e);
            }
        }
}